import {
	$addContactsModalStyles,
	$contactColumns,
	columnHeaders,
	sortKeys
} from 'features/contacts/utils/columns'
import { memo } from 'react'
import { Param } from 'shared/search-adapters'
import { ContactsTable, SearchPagination } from 'shared/ui'

import type { ContactTable as Props } from '../../types'

import { InfoCells } from '../GeneralTable/InfoCells'
import { AddButton } from './AddButton'

const Headers = () => (
	<ContactsTable.SortableHeadCells
		columnsStore={$contactColumns}
		headlineDictionary={columnHeaders}
		sortDictionary={sortKeys}
		sortKey={Param.OrderModal}
	/>
)

const HeaderActions = (props: ContactsTable.Types.ActionsProps) => (
	<AddButton className={ContactsTable.css.activeControlButton} {...props} />
)

function Table_({ contacts, filter, total }: Props) {
	return (
		<>
			<ContactsTable.Wrapper store={$addContactsModalStyles}>
				<ContactsTable.SelectWrap
					Actions={HeaderActions}
					filter={filter}
					Headers={Headers}
					items={contacts}
					Row={InfoCells}
					total={total}
				/>
			</ContactsTable.Wrapper>

			<SearchPagination skipKey={Param.ModalSkip} total={total} />
		</>
	)
}

export const Table = memo(Table_)
